import React from 'react'
import DivReferencia from './DivReferencia'
import { Box } from '@mui/material';
import FooterReferencia from './FooterReferencia';
import { ModalReferencia } from './ModalReferencia';


const REFERENCIAS = [
    {
        titulo: 'BAJA',
        valor: '0-2',
        recomendacion1: 'No requiere protección.',
        icoRecomendacion1: 'ico_recomendacion_1_baja.svg',
        recomendacion2: '',
        icoRecomendacion2: '',
        recomendacion3: '',
        icoRecomendacion3: '',
        bgColor: '#6E9813'  //'#83BB00',
    },
    {
        titulo: 'MODERADA',
        valor: '3-5',
        recomendacion1: "Busca sombra entre las \n 10-16 hs.",
        icoRecomendacion1: 'ico_recomendacion_1_moderada.svg',
        recomendacion2: 'Usa ropa que cubra tu piel, \n lentes y protector solar',
        icoRecomendacion2: 'ico_recomendacion_2_moderada.svg',
        recomendacion3: '',
        icoRecomendacion3: '',
        bgColor: '#F9C216' //'#FBC116',
    },
    {
        titulo: 'ALTA',
        valor: '6-7',
        recomendacion1: 'Reducí el tiempo de exposición \n al sol entre las 10-16 hs.',
        icoRecomendacion1: 'ico_recomendacion_1_alta.svg',
        recomendacion2: 'Usa ropa que cubra tu piel, \n lentes y protector solar',
        icoRecomendacion2: 'ico_recomendacion_2_alta.svg',
        recomendacion3: '',
        icoRecomendacion3: '',
        bgColor: '#FA6D0E' // '#FA6E10',
    },
    {
        titulo: 'MUY ALTA',
        valor: '8-10',
        recomendacion1: 'Minimizá la exposición al sol \n entre las 10-16 hs.',
        icoRecomendacion1: 'ico_recomendacion_1_alta.svg',
        recomendacion2: 'Usa ropa que cubra tu piel, \n lentes y protector solar',
        icoRecomendacion2: 'ico_recomendacion_2_alta.svg',
        recomendacion3: 'La piel y los ojos sin \n protección pueden dañarse y \n quemarse rápidamente',
        icoRecomendacion3: 'ico_recomendacion_3_muy.svg',
        bgColor: '#C61233' // '#A11351',
    },
    {
        titulo: 'EXTREMADAMENTE \n ALTA',
        valor: '11+',
        recomendacion1: 'Intentá evitar la exposición al \n sol entre las 10-16 hs.',
        icoRecomendacion1: 'ico_recomendacion_1_alta.svg',
        recomendacion2: 'Usa ropa que cubra tu piel, \n lentes y protector solar',
        icoRecomendacion2: 'ico_recomendacion_2_alta.svg',
        recomendacion3: 'La piel y los ojos sin \n protección pueden quemarse \n en minutos',
        icoRecomendacion3: 'ico_recomendacion_3_muy.svg',
        bgColor: '#651A76' //'#691A75',
    }
]



const Referencias = () => {

    return (

        <Box
            sx={{
                display: 'flex',
                flexGrow: 1,
                width: '100%',
                color: 'white',

                flexWrap: 'wrap',
                justifyContent: 'center',
                // marginTop: '5rem',


            }}
        >
            {REFERENCIAS.map((referencia) => <DivReferencia {...referencia} />)}


            <FooterReferencia />

        </Box>

    )
}


export default Referencias
